// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================= */
/* SIDEBAR COMPONENT STYLES - VANTA INSPIRED    */
/* ============================================= */

@keyframes sidebar-item-in {
  from { opacity: 0; transform: translateX(-6px); }
  to   { opacity: 1; transform: translateX(0); }
}

@keyframes active-glow-pulse {
  0%, 100% {
    box-shadow:
      0 2px 12px color-mix(in srgb, var(--app-primary-color, #26256b) 32%, transparent),
      0 1px 3px color-mix(in srgb, var(--app-primary-color, #26256b) 18%, transparent),
      inset 0 1px 0 rgba(255, 255, 255, 0.15);
  }
  50% {
    box-shadow:
      0 4px 22px color-mix(in srgb, var(--app-primary-color, #26256b) 50%, transparent),
      0 2px 6px color-mix(in srgb, var(--app-primary-color, #26256b) 28%, transparent),
      inset 0 1px 0 rgba(255, 255, 255, 0.20);
  }
}

.sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;
  color: #0f172a;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  border-right: 1px solid #e2e8f0;
}

.sidebar-dark {
  background: #1e293b;
  color: #f8fafc;
  border-right-color: #334155;
}

/* Sidebar Header */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
  height: 72px;
}

.sidebar-dark .sidebar-header {
  border-bottom-color: #334155;
}

/* Sidebar Logo */
.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: default;
  transition: opacity 200ms ease, transform 200ms ease;
}

.sidebar-logo:hover {
  opacity: 0.9;
  transform: translateX(1px);
}

.sidebar-logo-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 0.5rem;
  flex-shrink: 0;
  color: white;
  transition: transform 200ms ease, box-shadow 200ms ease;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.08),
    0 4px 8px -2px rgba(0, 0, 0, 0.1);
}

.sidebar-logo:hover .sidebar-logo-icon {
  transform: rotate(-4deg) scale(1.08);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
}

.sidebar-dark .sidebar-logo-icon {
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.2),
    0 4px 8px -2px rgba(0, 0, 0, 0.25);
}

.sidebar-logo-svg {
  width: 15px;
  height: 15px;
}

.sidebar-logo-info {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.sidebar-logo-name {
  font-size: 1rem;
  font-weight: 700 !important;
  letter-spacing: -0.02em !important;
  line-height: 1.15;
  font-family: 'Inter', 'SF Pro Display', system-ui, sans-serif;
  background: linear-gradient(
    118deg,
    var(--app-primary-color, #26256b) 0%,
    color-mix(in srgb, var(--app-primary-color, #26256b), #6366f1 55%) 50%,
    color-mix(in srgb, var(--app-primary-color, #26256b), #000 30%) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  color: transparent !important;
  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.08));
  transition: filter 200ms ease;
}

.sidebar-logo:hover .sidebar-logo-name {
  filter: drop-shadow(0 2px 6px color-mix(in srgb, var(--app-primary-color, #26256b), transparent 55%));
}

.sidebar-dark .sidebar-logo-name {
  background: linear-gradient(
    118deg,
    color-mix(in srgb, var(--app-primary-color, #38bdf8), #fff 45%) 0%,
    color-mix(in srgb, var(--app-primary-color, #38bdf8), #a5f3fc 30%) 50%,
    var(--app-primary-color, #38bdf8) 100%
  );
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  color: transparent !important;
  filter: drop-shadow(0 1px 3px rgba(0,0,0,0.25));
}

.sidebar-logo-tagline {
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.3;
  opacity: 0.42;
  font-family: 'Inter', system-ui, sans-serif;
}

/* Sidebar Close Button (Mobile) */
.sidebar-close-btn {
  background: none !important;
  border: none !important;
  padding: 0.375rem;
  border-radius: 0.5rem !important;
  cursor: pointer;
  color: #64748b !important;
  transition: all 200ms ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-close-btn:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.sidebar-dark .sidebar-close-btn {
  color: #94a3b8;
}

.sidebar-dark .sidebar-close-btn:hover {
  background: #334155;
  color: #f8fafc;
}

.sidebar-close-icon {
  width: 1.5rem;
  height: 1.5rem;
}

/* Override global a { color } for all links inside sidebar */
.sidebar a {
  color: inherit;
  text-decoration: none;
}
.sidebar a:hover {
  color: inherit;
}

/* Group label button — override global button styles */
.sidebar-group-label {
  background: none !important;
  border: none !important;
  border-radius: 0.375rem !important;
  cursor: pointer;
  font-family: 'Inter', system-ui, sans-serif;
  transition: color 160ms ease;
  box-shadow: none !important;
  outline: none !important;
}

/* Sidebar Navigation */
.sidebar-nav {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.5rem 0.5rem;
}

.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.sidebar-dark .sidebar-nav::-webkit-scrollbar-thumb {
  background: #475569;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.sidebar-dark .sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: #64748b;
}

/* ─────────────────────────────────────────────
   NAV LIST — enterprise spacing & section feel
   ───────────────────────────────────────────── */
.sidebar-nav-list {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding-bottom: 0.5rem;
}

/* Section dividers between groups */
.sidebar-nav-list > .sidebar-group-divider {
  height: 1px;
  margin: 0.5rem 0.75rem;
  background: linear-gradient(90deg, transparent, #e2e8f0 30%, #e2e8f0 70%, transparent);
  flex-shrink: 0;
}

.sidebar-dark .sidebar-nav-list > .sidebar-group-divider {
  background: linear-gradient(90deg, transparent, #334155 30%, #334155 70%, transparent);
}

/* ─────────────────────────────────────────────
   GROUP LABEL (collapsible section header)
   ───────────────────────────────────────────── */
.sidebar-group-label {
  background: none !important;
  border: none !important;
  border-radius: 0.375rem !important;
  cursor: pointer;
  font-family: 'Inter', system-ui, sans-serif;
  transition: color 160ms ease, background 160ms ease;
  box-shadow: none !important;
  outline: none !important;
  /* Extra enterprise feel */
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.45rem 0.75rem 0.3rem 0.75rem;
  margin-top: 0.625rem;
  position: relative;
}

/* Accent line before active group label */
.sidebar-group-label::before {
  content: '';
  position: absolute;
  left: 0;
  top: 30%;
  bottom: 30%;
  width: 2px;
  border-radius: 0 1px 1px 0;
  background: var(--app-primary-color, #26256b);
  opacity: 0;
  transition: opacity 180ms ease;
}

.sidebar-group-label[data-active='true']::before {
  opacity: 1;
}

.sidebar-group-label-text {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.sidebar-group-label-text::before {
  content: '';
  display: inline-block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.45;
  flex-shrink: 0;
}

.sidebar-group-label-chevron {
  width: 0.75rem;
  height: 0.75rem;
  flex-shrink: 0;
  opacity: 0.5;
  transition: transform 200ms ease, opacity 180ms ease;
}

.sidebar-group-label:hover .sidebar-group-label-chevron {
  opacity: 0.9;
}

/* ─────────────────────────────────────────────
   NAV ITEM WRAPPER
   ───────────────────────────────────────────── */
.sidebar-nav-item-wrapper {
  width: 100%;
}

/* ─────────────────────────────────────────────
   NAV ITEM BASE
   ───────────────────────────────────────────── */
.sidebar .sidebar-nav-item,
.sidebar-nav-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.48rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #64748b !important;
  text-decoration: none !important;
  transition:
    color 160ms cubic-bezier(0.4, 0, 0.2, 1),
    background 160ms cubic-bezier(0.4, 0, 0.2, 1),
    padding-left 160ms cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 160ms cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  gap: 0.625rem;
  position: relative;
  overflow: hidden;
  letter-spacing: 0.005em;
}

/* Left accent bar (animated on hover) */
.sidebar .sidebar-nav-item::before,
.sidebar-nav-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 18%;
  bottom: 18%;
  width: 2.5px;
  border-radius: 0 2px 2px 0;
  background: var(--app-primary-color, #26256b);
  transform: scaleY(0);
  transition: transform 180ms cubic-bezier(0.34, 1.56, 0.64, 1);
  transform-origin: center;
}

.sidebar .sidebar-nav-item:hover::before,
.sidebar-nav-item:hover::before {
  transform: scaleY(1);
}

/* Hide left bar on active — active has its own gradient */
.sidebar .sidebar-nav-item-active::before,
.sidebar-nav-item-active::before {
  display: none;
}

/* Hover state */
.sidebar .sidebar-nav-item:hover,
.sidebar-nav-item:hover {
  color: #1e293b !important;
  background: linear-gradient(90deg, #f1f5f9 0%, #f8fafc 100%);
  padding-left: 1rem;
  box-shadow: inset 0 0 0 1px rgba(99, 102, 241, 0.06);
}

/* Dark hover */
.sidebar-dark .sidebar-nav-item,
.sidebar-dark .sidebar .sidebar-nav-item {
  color: #94a3b8 !important;
}

.sidebar-dark .sidebar-nav-item:hover,
.sidebar-dark .sidebar .sidebar-nav-item:hover {
  color: #f1f5f9 !important;
  background: linear-gradient(90deg, #1e293b 0%, #263347 100%);
  padding-left: 1rem;
  box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.08);
}

/* ─────────────────────────────────────────────
   ACTIVE NAV ITEM — premium gradient + glow
   ───────────────────────────────────────────── */
.sidebar .sidebar-nav-item-active,
.sidebar-nav-item-active {
  color: white !important;
  background: linear-gradient(
    135deg,
    var(--app-primary-color, #26256b) 0%,
    color-mix(in srgb, var(--app-primary-color, #26256b), #4f46e5 40%) 60%,
    color-mix(in srgb, var(--app-primary-color, #26256b), black 20%) 100%
  );
  box-shadow:
    0 2px 12px color-mix(in srgb, var(--app-primary-color, #26256b) 32%, transparent),
    0 1px 3px color-mix(in srgb, var(--app-primary-color, #26256b) 18%, transparent),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
  font-weight: 600;
  padding-left: 0.875rem;
  animation: active-glow-pulse 3.5s ease-in-out infinite;
}

/* Active item — glowing icon */
.sidebar .sidebar-nav-item-active::after,
.sidebar-nav-item-active::after {
  content: '';
  position: absolute;
  right: 0.6rem;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 0 6px 2px rgba(255, 255, 255, 0.35);
}

.sidebar .sidebar-nav-item-active:hover,
.sidebar-nav-item-active:hover {
  padding-left: 1rem;
  filter: brightness(1.07);
  box-shadow:
    0 4px 20px color-mix(in srgb, var(--app-primary-color, #26256b) 45%, transparent),
    0 2px 6px color-mix(in srgb, var(--app-primary-color, #26256b) 25%, transparent),
    inset 0 1px 0 rgba(255, 255, 255, 0.18);
  color: white !important;
}

/* Dark mode active — use lighter brand color for visibility on dark bg */
.sidebar-dark .sidebar-nav-item-active,
.sidebar-dark .sidebar .sidebar-nav-item-active {
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--app-primary-color, #26256b), white 30%) 0%,
    color-mix(in srgb, var(--app-primary-color, #26256b), #6366f1 50%) 60%,
    color-mix(in srgb, var(--app-primary-color, #26256b), white 12%) 100%
  );
  box-shadow:
    0 2px 14px color-mix(in srgb, var(--app-primary-color, #26256b) 45%, transparent),
    0 1px 3px color-mix(in srgb, var(--app-primary-color, #26256b) 28%, transparent),
    inset 0 1px 0 rgba(255, 255, 255, 0.18);
  color: white !important;
}

.sidebar-dark .sidebar-nav-item-active:hover,
.sidebar-dark .sidebar .sidebar-nav-item-active:hover {
  padding-left: 1rem;
  filter: brightness(1.15);
  color: white !important;
}

/* ─────────────────────────────────────────────
   NAVIGATION ICON
   ───────────────────────────────────────────── */
.sidebar-nav-icon {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  transition: transform 180ms cubic-bezier(0.34, 1.56, 0.64, 1), opacity 160ms ease;
  opacity: 0.75;
}

.sidebar-nav-item:hover .sidebar-nav-icon {
  transform: scale(1.18) rotate(-3deg);
  opacity: 1;
}

.sidebar-nav-item-active .sidebar-nav-icon {
  transform: scale(1.12);
  opacity: 1;
  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.55));
}

/* ─────────────────────────────────────────────
   NAVIGATION TEXT
   ───────────────────────────────────────────── */
.sidebar-nav-text {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: letter-spacing 160ms ease;
}

.sidebar-nav-item:hover .sidebar-nav-text {
  letter-spacing: 0.01em;
}

.sidebar-nav-item-active .sidebar-nav-text {
  letter-spacing: 0.01em;
}

/* Sidebar Footer */
.sidebar-footer {
  padding: 0.625rem 0.5rem;
  border-top: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.sidebar-dark .sidebar-footer {
  border-top-color: #334155;
}

/* Logout Button */
.sidebar-logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: none !important;
  border-radius: 0.5rem !important;
  font-size: 0.8125rem;
  font-weight: 600 !important;
  color: white !important;
  background: linear-gradient(135deg, var(--app-primary-color, #26256b) 0%, color-mix(in srgb, var(--app-primary-color, #26256b), black 15%) 100%);
  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.15);
  cursor: pointer;
  transition: all 200ms ease-in-out;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.sidebar-logout-btn:hover {
  filter: brightness(0.9);
  box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.25);
  transform: translateY(-1px);
}

.sidebar-logout-btn:active {
  transform: translateY(0);
}

.sidebar-logout-icon {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}

.sidebar-logout-text {
  display: none;
}

@media (min-width: 768px) {
  .sidebar-logout-text {
    display: inline;
  }

  .sidebar-nav-text {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  }
}

/* Mobile Sidebar */
.sidebar-mobile-overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
}

@media (min-width: 768px) {
  .sidebar-mobile-overlay {
    display: none;
  }
}

.sidebar-mobile-panel {
  position: relative;
  width: 280px;
  height: 100%;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.sidebar-mobile-backdrop {
  flex: 1 1;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  cursor: pointer;
}

/* Desktop Sidebar */
@media (min-width: 768px) {
  .sidebar {
    /* Position is handled by the parent motion.div wrapper in Layout.js */
    width: 100%;
    height: 100%;
    border-radius: 0;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  }

  .sidebar-close-btn {
    display: none;
  }

  .sidebar-mobile-overlay {
    display: none;
  }
}

/* Responsive */
@media (max-width: 767px) {
  .sidebar-header {
    padding: 0.875rem 1rem;
    min-height: 56px;
  }

  .sidebar-logo-icon {
    width: 32px;
    height: 32px;
  }

  .sidebar-logo-svg {
    width: 18px;
    height: 18px;
  }

  .sidebar-logo-name {
    font-size: 0.875rem;
  }

  .sidebar-logo-tagline {
    font-size: 0.5rem;
  }

  .sidebar-nav-item {
    padding: 0.625rem 0.75rem;
    font-size: 0.8125rem;
    gap: 0.5rem;
  }

  .sidebar-nav-icon {
    width: 1.125rem;
    height: 1.125rem;
  }
}

/* ============================================= */
/* HORIZONTAL SIDEBAR (Top Navigation Bar)      */
/* ============================================= */

.sidebar-horizontal {
  display: flex;
  align-items: center;
  height: 52px;
  padding: 0 1.25rem;
  border-bottom: 1px solid #E2E8F0;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 45;
  gap: 1.5rem;
}

.sidebar-dark.sidebar-horizontal {
  background: #0F172A;
  border-bottom-color: #334155;
}

.sidebar-horizontal-logo {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  flex-shrink: 0;
  padding-right: 1.25rem;
  border-right: 1px solid #E2E8F0;
  margin-right: 0.25rem;
}

.sidebar-dark .sidebar-horizontal-logo {
  border-right-color: #334155;
}

.sidebar-horizontal-brand {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.sidebar-horizontal-nav {
  display: flex;
  align-items: center;
  gap: 0.125rem;
  flex: 1 1;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.sidebar-horizontal-nav::-webkit-scrollbar {
  display: none;
}

.sidebar-horizontal-item {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.625rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  text-decoration: none !important;
  color: inherit !important;
  transition: all 150ms ease;
  border-bottom: 2px solid transparent;
  flex-shrink: 0;
}

.sidebar-horizontal-item:hover {
  background: #F1F5F9;
}

.sidebar-dark .sidebar-horizontal-item:hover {
  background: #1E293B;
}

.sidebar-horizontal-item-active {
  font-weight: 600;
  border-bottom-color: currentColor;
  background: transparent !important;
}

.sidebar-horizontal-icon {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}

.sidebar-horizontal-text {
  display: inline;
}

/* ============================================= */
/* COMPACT SIDEBAR (Icon-only)                  */
/* ============================================= */

.sidebar-compact {
  width: 72px !important;
  align-items: center;
}

.sidebar-compact-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  border-bottom: 1px solid #334155;
  flex-shrink: 0;
  width: 100%;
}

.sidebar-compact-nav {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.75rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
}

.sidebar-compact-nav::-webkit-scrollbar {
  width: 0;
}

.sidebar-compact-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 0.625rem;
  text-decoration: none;
  transition: all 150ms ease;
  position: relative;
}

.sidebar-compact-item:hover::after {
  content: attr(title);
  position: absolute;
  left: calc(100% + 12px);
  top: 50%;
  transform: translateY(-50%);
  background: #1E293B;
  color: #F8FAFC;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.375rem 0.75rem;
  border-radius: 0.375rem;
  white-space: nowrap;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: none;
}

.sidebar-compact-item-active {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.sidebar-compact-icon {
  width: 1.25rem;
  height: 1.25rem;
}

/* ============================================= */
/* COLLAPSED SIDEBAR — icon-only                 */
/* ============================================= */

.sidebar-collapsed-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ═══════════════════════════════════════════════════ */
/* CORPORATE LAYOUT — dark branded sidebar overrides  */
/* ═══════════════════════════════════════════════════ */

/* Depth shadow separating sidebar from content */
.sidebar-layout-corporate {
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.22), 1px 0 0 rgba(255, 255, 255, 0.05);
}

/* Logo icon: glass-white tile on branded bg */
.sidebar-layout-corporate .sidebar-logo-icon {
  background: rgba(255, 255, 255, 0.14) !important;
  border: 1px solid rgba(255, 255, 255, 0.22) !important;
  box-shadow:
    0 1px 4px rgba(0, 0, 0, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.22) !important;
  color: #fff;
}

/* Logo name: crisp white-to-lavender gradient */
.sidebar-layout-corporate .sidebar-logo-name,
.sidebar-dark.sidebar-layout-corporate .sidebar-logo-name {
  background: linear-gradient(118deg, #ffffff 0%, #e8e7ff 55%, #c4c3e8 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  filter: none !important;
}

/* Logo tagline */
.sidebar-layout-corporate .sidebar-logo-tagline {
  color: rgba(255, 255, 255, 0.42) !important;
  opacity: 1 !important;
}

/* Nav item hover — white glass instead of slate gradient */
.sidebar-layout-corporate .sidebar-nav-item:hover,
.sidebar-dark.sidebar-layout-corporate .sidebar-nav-item:hover {
  background: rgba(255, 255, 255, 0.09) !important;
  color: #ffffff !important;
  box-shadow: none !important;
}

/* Active item — disable the blue glow animation */
.sidebar-layout-corporate .sidebar-nav-item-active,
.sidebar-dark.sidebar-layout-corporate .sidebar-nav-item-active {
  animation: none !important;
}

/* Active item trailing dot — white */
.sidebar-layout-corporate .sidebar-nav-item-active::after,
.sidebar-dark.sidebar-layout-corporate .sidebar-nav-item-active::after {
  background: rgba(255, 255, 255, 0.65) !important;
  box-shadow: 0 0 6px 2px rgba(255, 255, 255, 0.22) !important;
}

/* Left accent bar on hover — white */
.sidebar-layout-corporate .sidebar-nav-item::before {
  background: rgba(255, 255, 255, 0.6);
}

/* Group label text */
.sidebar-layout-corporate .sidebar-group-label {
  color: rgba(255, 255, 255, 0.38) !important;
}

.sidebar-layout-corporate .sidebar-group-label:hover {
  color: rgba(255, 255, 255, 0.6) !important;
}

.sidebar-layout-corporate .sidebar-group-label[data-active='true'] {
  color: rgba(255, 255, 255, 0.82) !important;
}

/* Group label accent line — white */
.sidebar-layout-corporate .sidebar-group-label::before {
  background: rgba(255, 255, 255, 0.55);
}

/* Scrollbar — lighter for dark branded bg */
.sidebar-layout-corporate .sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.14);
}

.sidebar-layout-corporate .sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.26);
}

/* Section border in header */
.sidebar-layout-corporate .sidebar-header {
  border-bottom-color: rgba(255, 255, 255, 0.10) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/Sidebar.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,iDAAiD;AACjD,kDAAkD;;AAElD;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE;IACE;;;6CAGyC;EAC3C;EACA;IACE;;;6CAGyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kDAAkD;EAClD,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,uDAAuD;EACvD;;qCAEmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE;;sCAEoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;EAClC,iBAAiB;EACjB,6DAA6D;EAC7D;;;;;GAKC;EACD,wCAAwC;EACxC,+CAA+C;EAC/C,gCAAgC;EAChC,6BAA6B;EAC7B,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;EACE,qGAAqG;AACvG;;AAEA;EACE;;;;;GAKC;EACD,wCAAwC;EACxC,+CAA+C;EAC/C,gCAAgC;EAChC,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;AAC7C;;AAEA,kCAAkC;AAClC;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,2CAA2C;EAC3C,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;kDAEkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,sBAAsB;EACtB,sFAAsF;EACtF,cAAc;AAChB;;AAEA;EACE,sFAAsF;AACxF;;AAEA;;kDAEkD;AAClD;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,2CAA2C;EAC3C,mDAAmD;EACnD,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,uCAAuC;EACvC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,6CAA6C;EAC7C,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,YAAY;AACd;;AAEA;;kDAEkD;AAClD;EACE,WAAW;AACb;;AAEA;;kDAEkD;AAClD;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC;;;;iDAI+C;EAC/C,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,6CAA6C;EAC7C,oBAAoB;EACpB,6DAA6D;EAC7D,wBAAwB;AAC1B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA,0DAA0D;AAC1D;;EAEE,aAAa;AACf;;AAEA,gBAAgB;AAChB;;EAEE,yBAAyB;EACzB,4DAA4D;EAC5D,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA,eAAe;AACf;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,4DAA4D;EAC5D,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;;kDAEkD;AAClD;;EAEE,uBAAuB;EACvB;;;;;GAKC;EACD;;;2CAGyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA,+BAA+B;AAC/B;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB;;;2CAGyC;EACzC,uBAAuB;AACzB;;AAEA,yEAAyE;AACzE;;EAEE;;;;;GAKC;EACD;;;2CAGyC;EACzC,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;;kDAEkD;AAClD;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iFAAiF;EACjF,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,sDAAsD;AACxD;;AAEA;;kDAEkD;AAClD;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,2BAA2B;EAC3B,uBAAuB;EACvB,gJAAgJ;EAChJ,kDAAkD;EAClD,eAAe;EACf,iCAAiC;EACjC,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;EACvB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE;IACE,sEAAsE;IACtE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,+CAA+C;EACjD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,kDAAkD;AAClD,iDAAiD;AACjD,kDAAkD;;AAElD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;EAC1B,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,kDAAkD;AAClD,iDAAiD;AACjD,kDAAkD;;AAElD;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kDAAkD;AAClD,kDAAkD;AAClD,kDAAkD;;AAElD;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,wDAAwD;AACxD,uDAAuD;AACvD,wDAAwD;;AAExD,iDAAiD;AACjD;EACE,6EAA6E;AAC/E;;AAEA,8CAA8C;AAC9C;EACE,gDAAgD;EAChD,sDAAsD;EACtD;;sDAEoD;EACpD,WAAW;AACb;;AAEA,gDAAgD;AAChD;;EAEE,qFAAqF;EACrF,wCAAwC;EACxC,+CAA+C;EAC/C,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;;EAEE,gDAAgD;EAChD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;;EAEE,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;;EAEE,gDAAgD;EAChD,4DAA4D;AAC9D;;AAEA,qCAAqC;AACrC;EACE,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,oCAAoC;AACpC;EACE,qCAAqC;AACvC;;AAEA,4CAA4C;AAC5C;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;EACE,yDAAyD;AAC3D","sourcesContent":["/* ============================================= */\n/* SIDEBAR COMPONENT STYLES - VANTA INSPIRED    */\n/* ============================================= */\n\n@keyframes sidebar-item-in {\n  from { opacity: 0; transform: translateX(-6px); }\n  to   { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes active-glow-pulse {\n  0%, 100% {\n    box-shadow:\n      0 2px 12px color-mix(in srgb, var(--app-primary-color, #26256b) 32%, transparent),\n      0 1px 3px color-mix(in srgb, var(--app-primary-color, #26256b) 18%, transparent),\n      inset 0 1px 0 rgba(255, 255, 255, 0.15);\n  }\n  50% {\n    box-shadow:\n      0 4px 22px color-mix(in srgb, var(--app-primary-color, #26256b) 50%, transparent),\n      0 2px 6px color-mix(in srgb, var(--app-primary-color, #26256b) 28%, transparent),\n      inset 0 1px 0 rgba(255, 255, 255, 0.20);\n  }\n}\n\n.sidebar {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: white;\n  color: #0f172a;\n  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);\n  border-right: 1px solid #e2e8f0;\n}\n\n.sidebar-dark {\n  background: #1e293b;\n  color: #f8fafc;\n  border-right-color: #334155;\n}\n\n/* Sidebar Header */\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.625rem 1rem;\n  border-bottom: 1px solid #e2e8f0;\n  flex-shrink: 0;\n  height: 72px;\n}\n\n.sidebar-dark .sidebar-header {\n  border-bottom-color: #334155;\n}\n\n/* Sidebar Logo */\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: default;\n  transition: opacity 200ms ease, transform 200ms ease;\n}\n\n.sidebar-logo:hover {\n  opacity: 0.9;\n  transform: translateX(1px);\n}\n\n.sidebar-logo-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 0.5rem;\n  flex-shrink: 0;\n  color: white;\n  transition: transform 200ms ease, box-shadow 200ms ease;\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.08),\n    0 4px 8px -2px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-logo:hover .sidebar-logo-icon {\n  transform: rotate(-4deg) scale(1.08);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);\n}\n\n.sidebar-dark .sidebar-logo-icon {\n  box-shadow:\n    0 1px 3px rgba(0, 0, 0, 0.2),\n    0 4px 8px -2px rgba(0, 0, 0, 0.25);\n}\n\n.sidebar-logo-svg {\n  width: 15px;\n  height: 15px;\n}\n\n.sidebar-logo-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n  min-width: 0;\n}\n\n.sidebar-logo-name {\n  font-size: 1rem;\n  font-weight: 700 !important;\n  letter-spacing: -0.02em !important;\n  line-height: 1.15;\n  font-family: 'Inter', 'SF Pro Display', system-ui, sans-serif;\n  background: linear-gradient(\n    118deg,\n    var(--app-primary-color, #26256b) 0%,\n    color-mix(in srgb, var(--app-primary-color, #26256b), #6366f1 55%) 50%,\n    color-mix(in srgb, var(--app-primary-color, #26256b), #000 30%) 100%\n  );\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n  background-clip: text !important;\n  color: transparent !important;\n  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.08));\n  transition: filter 200ms ease;\n}\n\n.sidebar-logo:hover .sidebar-logo-name {\n  filter: drop-shadow(0 2px 6px color-mix(in srgb, var(--app-primary-color, #26256b), transparent 55%));\n}\n\n.sidebar-dark .sidebar-logo-name {\n  background: linear-gradient(\n    118deg,\n    color-mix(in srgb, var(--app-primary-color, #38bdf8), #fff 45%) 0%,\n    color-mix(in srgb, var(--app-primary-color, #38bdf8), #a5f3fc 30%) 50%,\n    var(--app-primary-color, #38bdf8) 100%\n  );\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n  background-clip: text !important;\n  color: transparent !important;\n  filter: drop-shadow(0 1px 3px rgba(0,0,0,0.25));\n}\n\n.sidebar-logo-tagline {\n  font-size: 0.72rem;\n  font-weight: 500;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.3;\n  opacity: 0.42;\n  font-family: 'Inter', system-ui, sans-serif;\n}\n\n/* Sidebar Close Button (Mobile) */\n.sidebar-close-btn {\n  background: none !important;\n  border: none !important;\n  padding: 0.375rem;\n  border-radius: 0.5rem !important;\n  cursor: pointer;\n  color: #64748b !important;\n  transition: all 200ms ease-in-out;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar-close-btn:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.sidebar-dark .sidebar-close-btn {\n  color: #94a3b8;\n}\n\n.sidebar-dark .sidebar-close-btn:hover {\n  background: #334155;\n  color: #f8fafc;\n}\n\n.sidebar-close-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n/* Override global a { color } for all links inside sidebar */\n.sidebar a {\n  color: inherit;\n  text-decoration: none;\n}\n.sidebar a:hover {\n  color: inherit;\n}\n\n/* Group label button — override global button styles */\n.sidebar-group-label {\n  background: none !important;\n  border: none !important;\n  border-radius: 0.375rem !important;\n  cursor: pointer;\n  font-family: 'Inter', system-ui, sans-serif;\n  transition: color 160ms ease;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* Sidebar Navigation */\n.sidebar-nav {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.5rem 0.5rem;\n}\n\n.sidebar-nav::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.sidebar-dark .sidebar-nav::-webkit-scrollbar-thumb {\n  background: #475569;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.sidebar-dark .sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: #64748b;\n}\n\n/* ─────────────────────────────────────────────\n   NAV LIST — enterprise spacing & section feel\n   ───────────────────────────────────────────── */\n.sidebar-nav-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  padding-bottom: 0.5rem;\n}\n\n/* Section dividers between groups */\n.sidebar-nav-list > .sidebar-group-divider {\n  height: 1px;\n  margin: 0.5rem 0.75rem;\n  background: linear-gradient(90deg, transparent, #e2e8f0 30%, #e2e8f0 70%, transparent);\n  flex-shrink: 0;\n}\n\n.sidebar-dark .sidebar-nav-list > .sidebar-group-divider {\n  background: linear-gradient(90deg, transparent, #334155 30%, #334155 70%, transparent);\n}\n\n/* ─────────────────────────────────────────────\n   GROUP LABEL (collapsible section header)\n   ───────────────────────────────────────────── */\n.sidebar-group-label {\n  background: none !important;\n  border: none !important;\n  border-radius: 0.375rem !important;\n  cursor: pointer;\n  font-family: 'Inter', system-ui, sans-serif;\n  transition: color 160ms ease, background 160ms ease;\n  box-shadow: none !important;\n  outline: none !important;\n  /* Extra enterprise feel */\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0.45rem 0.75rem 0.3rem 0.75rem;\n  margin-top: 0.625rem;\n  position: relative;\n}\n\n/* Accent line before active group label */\n.sidebar-group-label::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 30%;\n  bottom: 30%;\n  width: 2px;\n  border-radius: 0 1px 1px 0;\n  background: var(--app-primary-color, #26256b);\n  opacity: 0;\n  transition: opacity 180ms ease;\n}\n\n.sidebar-group-label[data-active='true']::before {\n  opacity: 1;\n}\n\n.sidebar-group-label-text {\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n}\n\n.sidebar-group-label-text::before {\n  content: '';\n  display: inline-block;\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0.45;\n  flex-shrink: 0;\n}\n\n.sidebar-group-label-chevron {\n  width: 0.75rem;\n  height: 0.75rem;\n  flex-shrink: 0;\n  opacity: 0.5;\n  transition: transform 200ms ease, opacity 180ms ease;\n}\n\n.sidebar-group-label:hover .sidebar-group-label-chevron {\n  opacity: 0.9;\n}\n\n/* ─────────────────────────────────────────────\n   NAV ITEM WRAPPER\n   ───────────────────────────────────────────── */\n.sidebar-nav-item-wrapper {\n  width: 100%;\n}\n\n/* ─────────────────────────────────────────────\n   NAV ITEM BASE\n   ───────────────────────────────────────────── */\n.sidebar .sidebar-nav-item,\n.sidebar-nav-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0.48rem 0.75rem;\n  border-radius: 0.5rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #64748b !important;\n  text-decoration: none !important;\n  transition:\n    color 160ms cubic-bezier(0.4, 0, 0.2, 1),\n    background 160ms cubic-bezier(0.4, 0, 0.2, 1),\n    padding-left 160ms cubic-bezier(0.4, 0, 0.2, 1),\n    box-shadow 160ms cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n  gap: 0.625rem;\n  position: relative;\n  overflow: hidden;\n  letter-spacing: 0.005em;\n}\n\n/* Left accent bar (animated on hover) */\n.sidebar .sidebar-nav-item::before,\n.sidebar-nav-item::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 18%;\n  bottom: 18%;\n  width: 2.5px;\n  border-radius: 0 2px 2px 0;\n  background: var(--app-primary-color, #26256b);\n  transform: scaleY(0);\n  transition: transform 180ms cubic-bezier(0.34, 1.56, 0.64, 1);\n  transform-origin: center;\n}\n\n.sidebar .sidebar-nav-item:hover::before,\n.sidebar-nav-item:hover::before {\n  transform: scaleY(1);\n}\n\n/* Hide left bar on active — active has its own gradient */\n.sidebar .sidebar-nav-item-active::before,\n.sidebar-nav-item-active::before {\n  display: none;\n}\n\n/* Hover state */\n.sidebar .sidebar-nav-item:hover,\n.sidebar-nav-item:hover {\n  color: #1e293b !important;\n  background: linear-gradient(90deg, #f1f5f9 0%, #f8fafc 100%);\n  padding-left: 1rem;\n  box-shadow: inset 0 0 0 1px rgba(99, 102, 241, 0.06);\n}\n\n/* Dark hover */\n.sidebar-dark .sidebar-nav-item,\n.sidebar-dark .sidebar .sidebar-nav-item {\n  color: #94a3b8 !important;\n}\n\n.sidebar-dark .sidebar-nav-item:hover,\n.sidebar-dark .sidebar .sidebar-nav-item:hover {\n  color: #f1f5f9 !important;\n  background: linear-gradient(90deg, #1e293b 0%, #263347 100%);\n  padding-left: 1rem;\n  box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.08);\n}\n\n/* ─────────────────────────────────────────────\n   ACTIVE NAV ITEM — premium gradient + glow\n   ───────────────────────────────────────────── */\n.sidebar .sidebar-nav-item-active,\n.sidebar-nav-item-active {\n  color: white !important;\n  background: linear-gradient(\n    135deg,\n    var(--app-primary-color, #26256b) 0%,\n    color-mix(in srgb, var(--app-primary-color, #26256b), #4f46e5 40%) 60%,\n    color-mix(in srgb, var(--app-primary-color, #26256b), black 20%) 100%\n  );\n  box-shadow:\n    0 2px 12px color-mix(in srgb, var(--app-primary-color, #26256b) 32%, transparent),\n    0 1px 3px color-mix(in srgb, var(--app-primary-color, #26256b) 18%, transparent),\n    inset 0 1px 0 rgba(255, 255, 255, 0.15);\n  font-weight: 600;\n  padding-left: 0.875rem;\n  animation: active-glow-pulse 3.5s ease-in-out infinite;\n}\n\n/* Active item — glowing icon */\n.sidebar .sidebar-nav-item-active::after,\n.sidebar-nav-item-active::after {\n  content: '';\n  position: absolute;\n  right: 0.6rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.7);\n  box-shadow: 0 0 6px 2px rgba(255, 255, 255, 0.35);\n}\n\n.sidebar .sidebar-nav-item-active:hover,\n.sidebar-nav-item-active:hover {\n  padding-left: 1rem;\n  filter: brightness(1.07);\n  box-shadow:\n    0 4px 20px color-mix(in srgb, var(--app-primary-color, #26256b) 45%, transparent),\n    0 2px 6px color-mix(in srgb, var(--app-primary-color, #26256b) 25%, transparent),\n    inset 0 1px 0 rgba(255, 255, 255, 0.18);\n  color: white !important;\n}\n\n/* Dark mode active — use lighter brand color for visibility on dark bg */\n.sidebar-dark .sidebar-nav-item-active,\n.sidebar-dark .sidebar .sidebar-nav-item-active {\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--app-primary-color, #26256b), white 30%) 0%,\n    color-mix(in srgb, var(--app-primary-color, #26256b), #6366f1 50%) 60%,\n    color-mix(in srgb, var(--app-primary-color, #26256b), white 12%) 100%\n  );\n  box-shadow:\n    0 2px 14px color-mix(in srgb, var(--app-primary-color, #26256b) 45%, transparent),\n    0 1px 3px color-mix(in srgb, var(--app-primary-color, #26256b) 28%, transparent),\n    inset 0 1px 0 rgba(255, 255, 255, 0.18);\n  color: white !important;\n}\n\n.sidebar-dark .sidebar-nav-item-active:hover,\n.sidebar-dark .sidebar .sidebar-nav-item-active:hover {\n  padding-left: 1rem;\n  filter: brightness(1.15);\n  color: white !important;\n}\n\n/* ─────────────────────────────────────────────\n   NAVIGATION ICON\n   ───────────────────────────────────────────── */\n.sidebar-nav-icon {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n  transition: transform 180ms cubic-bezier(0.34, 1.56, 0.64, 1), opacity 160ms ease;\n  opacity: 0.75;\n}\n\n.sidebar-nav-item:hover .sidebar-nav-icon {\n  transform: scale(1.18) rotate(-3deg);\n  opacity: 1;\n}\n\n.sidebar-nav-item-active .sidebar-nav-icon {\n  transform: scale(1.12);\n  opacity: 1;\n  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.55));\n}\n\n/* ─────────────────────────────────────────────\n   NAVIGATION TEXT\n   ───────────────────────────────────────────── */\n.sidebar-nav-text {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: letter-spacing 160ms ease;\n}\n\n.sidebar-nav-item:hover .sidebar-nav-text {\n  letter-spacing: 0.01em;\n}\n\n.sidebar-nav-item-active .sidebar-nav-text {\n  letter-spacing: 0.01em;\n}\n\n/* Sidebar Footer */\n.sidebar-footer {\n  padding: 0.625rem 0.5rem;\n  border-top: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.sidebar-dark .sidebar-footer {\n  border-top-color: #334155;\n}\n\n/* Logout Button */\n.sidebar-logout-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: none !important;\n  border-radius: 0.5rem !important;\n  font-size: 0.8125rem;\n  font-weight: 600 !important;\n  color: white !important;\n  background: linear-gradient(135deg, var(--app-primary-color, #26256b) 0%, color-mix(in srgb, var(--app-primary-color, #26256b), black 15%) 100%);\n  box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.15);\n  cursor: pointer;\n  transition: all 200ms ease-in-out;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n}\n\n.sidebar-logout-btn:hover {\n  filter: brightness(0.9);\n  box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.25);\n  transform: translateY(-1px);\n}\n\n.sidebar-logout-btn:active {\n  transform: translateY(0);\n}\n\n.sidebar-logout-icon {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n}\n\n.sidebar-logout-text {\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .sidebar-logout-text {\n    display: inline;\n  }\n\n  .sidebar-nav-text {\n    white-space: normal;\n    overflow: visible;\n    text-overflow: clip;\n  }\n}\n\n/* Mobile Sidebar */\n.sidebar-mobile-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  display: flex;\n}\n\n@media (min-width: 768px) {\n  .sidebar-mobile-overlay {\n    display: none;\n  }\n}\n\n.sidebar-mobile-panel {\n  position: relative;\n  width: 280px;\n  height: 100%;\n  overflow-y: auto;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-mobile-backdrop {\n  flex: 1;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  cursor: pointer;\n}\n\n/* Desktop Sidebar */\n@media (min-width: 768px) {\n  .sidebar {\n    /* Position is handled by the parent motion.div wrapper in Layout.js */\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n  }\n\n  .sidebar-close-btn {\n    display: none;\n  }\n\n  .sidebar-mobile-overlay {\n    display: none;\n  }\n}\n\n/* Responsive */\n@media (max-width: 767px) {\n  .sidebar-header {\n    padding: 0.875rem 1rem;\n    min-height: 56px;\n  }\n\n  .sidebar-logo-icon {\n    width: 32px;\n    height: 32px;\n  }\n\n  .sidebar-logo-svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  .sidebar-logo-name {\n    font-size: 0.875rem;\n  }\n\n  .sidebar-logo-tagline {\n    font-size: 0.5rem;\n  }\n\n  .sidebar-nav-item {\n    padding: 0.625rem 0.75rem;\n    font-size: 0.8125rem;\n    gap: 0.5rem;\n  }\n\n  .sidebar-nav-icon {\n    width: 1.125rem;\n    height: 1.125rem;\n  }\n}\n\n/* ============================================= */\n/* HORIZONTAL SIDEBAR (Top Navigation Bar)      */\n/* ============================================= */\n\n.sidebar-horizontal {\n  display: flex;\n  align-items: center;\n  height: 52px;\n  padding: 0 1.25rem;\n  border-bottom: 1px solid #E2E8F0;\n  background: white;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 45;\n  gap: 1.5rem;\n}\n\n.sidebar-dark.sidebar-horizontal {\n  background: #0F172A;\n  border-bottom-color: #334155;\n}\n\n.sidebar-horizontal-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  flex-shrink: 0;\n  padding-right: 1.25rem;\n  border-right: 1px solid #E2E8F0;\n  margin-right: 0.25rem;\n}\n\n.sidebar-dark .sidebar-horizontal-logo {\n  border-right-color: #334155;\n}\n\n.sidebar-horizontal-brand {\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.sidebar-horizontal-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.125rem;\n  flex: 1;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.sidebar-horizontal-nav::-webkit-scrollbar {\n  display: none;\n}\n\n.sidebar-horizontal-item {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.375rem 0.625rem;\n  border-radius: 0.375rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  white-space: nowrap;\n  text-decoration: none !important;\n  color: inherit !important;\n  transition: all 150ms ease;\n  border-bottom: 2px solid transparent;\n  flex-shrink: 0;\n}\n\n.sidebar-horizontal-item:hover {\n  background: #F1F5F9;\n}\n\n.sidebar-dark .sidebar-horizontal-item:hover {\n  background: #1E293B;\n}\n\n.sidebar-horizontal-item-active {\n  font-weight: 600;\n  border-bottom-color: currentColor;\n  background: transparent !important;\n}\n\n.sidebar-horizontal-icon {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n}\n\n.sidebar-horizontal-text {\n  display: inline;\n}\n\n/* ============================================= */\n/* COMPACT SIDEBAR (Icon-only)                  */\n/* ============================================= */\n\n.sidebar-compact {\n  width: 72px !important;\n  align-items: center;\n}\n\n.sidebar-compact-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 0;\n  border-bottom: 1px solid #334155;\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.sidebar-compact-nav {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.75rem 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n  width: 100%;\n}\n\n.sidebar-compact-nav::-webkit-scrollbar {\n  width: 0;\n}\n\n.sidebar-compact-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 0.625rem;\n  text-decoration: none;\n  transition: all 150ms ease;\n  position: relative;\n}\n\n.sidebar-compact-item:hover::after {\n  content: attr(title);\n  position: absolute;\n  left: calc(100% + 12px);\n  top: 50%;\n  transform: translateY(-50%);\n  background: #1E293B;\n  color: #F8FAFC;\n  font-size: 0.75rem;\n  font-weight: 500;\n  padding: 0.375rem 0.75rem;\n  border-radius: 0.375rem;\n  white-space: nowrap;\n  z-index: 100;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  pointer-events: none;\n}\n\n.sidebar-compact-item-active {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.sidebar-compact-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n/* ============================================= */\n/* COLLAPSED SIDEBAR — icon-only                 */\n/* ============================================= */\n\n.sidebar-collapsed-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ═══════════════════════════════════════════════════ */\n/* CORPORATE LAYOUT — dark branded sidebar overrides  */\n/* ═══════════════════════════════════════════════════ */\n\n/* Depth shadow separating sidebar from content */\n.sidebar-layout-corporate {\n  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.22), 1px 0 0 rgba(255, 255, 255, 0.05);\n}\n\n/* Logo icon: glass-white tile on branded bg */\n.sidebar-layout-corporate .sidebar-logo-icon {\n  background: rgba(255, 255, 255, 0.14) !important;\n  border: 1px solid rgba(255, 255, 255, 0.22) !important;\n  box-shadow:\n    0 1px 4px rgba(0, 0, 0, 0.22),\n    inset 0 1px 0 rgba(255, 255, 255, 0.22) !important;\n  color: #fff;\n}\n\n/* Logo name: crisp white-to-lavender gradient */\n.sidebar-layout-corporate .sidebar-logo-name,\n.sidebar-dark.sidebar-layout-corporate .sidebar-logo-name {\n  background: linear-gradient(118deg, #ffffff 0%, #e8e7ff 55%, #c4c3e8 100%) !important;\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n  background-clip: text !important;\n  filter: none !important;\n}\n\n/* Logo tagline */\n.sidebar-layout-corporate .sidebar-logo-tagline {\n  color: rgba(255, 255, 255, 0.42) !important;\n  opacity: 1 !important;\n}\n\n/* Nav item hover — white glass instead of slate gradient */\n.sidebar-layout-corporate .sidebar-nav-item:hover,\n.sidebar-dark.sidebar-layout-corporate .sidebar-nav-item:hover {\n  background: rgba(255, 255, 255, 0.09) !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n/* Active item — disable the blue glow animation */\n.sidebar-layout-corporate .sidebar-nav-item-active,\n.sidebar-dark.sidebar-layout-corporate .sidebar-nav-item-active {\n  animation: none !important;\n}\n\n/* Active item trailing dot — white */\n.sidebar-layout-corporate .sidebar-nav-item-active::after,\n.sidebar-dark.sidebar-layout-corporate .sidebar-nav-item-active::after {\n  background: rgba(255, 255, 255, 0.65) !important;\n  box-shadow: 0 0 6px 2px rgba(255, 255, 255, 0.22) !important;\n}\n\n/* Left accent bar on hover — white */\n.sidebar-layout-corporate .sidebar-nav-item::before {\n  background: rgba(255, 255, 255, 0.6);\n}\n\n/* Group label text */\n.sidebar-layout-corporate .sidebar-group-label {\n  color: rgba(255, 255, 255, 0.38) !important;\n}\n\n.sidebar-layout-corporate .sidebar-group-label:hover {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\n\n.sidebar-layout-corporate .sidebar-group-label[data-active='true'] {\n  color: rgba(255, 255, 255, 0.82) !important;\n}\n\n/* Group label accent line — white */\n.sidebar-layout-corporate .sidebar-group-label::before {\n  background: rgba(255, 255, 255, 0.55);\n}\n\n/* Scrollbar — lighter for dark branded bg */\n.sidebar-layout-corporate .sidebar-nav::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.sidebar-layout-corporate .sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.26);\n}\n\n/* Section border in header */\n.sidebar-layout-corporate .sidebar-header {\n  border-bottom-color: rgba(255, 255, 255, 0.10) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
